import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={





    addExamine(state,value){
        
        
       
        post(urls.admin.examine.add,value).then((result)=>{
          

          
          state.result=result
        
       
        
       
           
        });
        
    },

  
    
   

    

}
const  actions={


    addExamineAction(context,value){
       
        context.commit("addExamine",value)
       
    },
  


    
    

}

export default {state,mutations,actions}